// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Page Styles */

.admin-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #f5f5f5;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.admin-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    background: #fff;
    border-bottom: 1px solid #e1e5e9;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.admin-header h1 {
    margin: 0;
    color: #333;
    font-size: 28px;
    font-weight: 600;
}

.refresh-btn {
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s ease;
}

.refresh-btn:hover {
    background: #0056b3;
}

.admin-content {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.admin-sidebar {
    width: 400px;
    background: #fff;
    border-right: 1px solid #e1e5e9;
    overflow-y: auto;
    padding: 20px;
}

.admin-sidebar h2 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 20px;
    font-weight: 600;
}

.room-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.room-item {
    padding: 16px;
    background: #f8f9fa;
    border: 1px solid #e1e5e9;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.room-item:hover {
    background: #e9ecef;
    border-color: #007bff;
}

.room-item.selected {
    background: #e3f2fd;
    border-color: #007bff;
}

.room-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.room-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.room-status {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
}

.room-status.active {
    background: #d4edda;
    color: #155724;
}

.room-status.inactive {
    background: #f8d7da;
    color: #721c24;
}

.room-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
}

.room-actions {
    display: flex;
    justify-content: flex-end;
}

.delete-btn {
    padding: 6px 12px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.2s ease;
}

.delete-btn:hover {
    background: #c82333;
}

.admin-main {
    flex: 1;
    background: #fff;
    padding: 30px;
    overflow-y: auto;
}

.room-details h2 {
    margin: 0 0 30px 0;
    color: #333;
    font-size: 24px;
    font-weight: 600;
}

.participants-list h3 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
    font-weight: 600;
}

.participants-table {
    border: 1px solid #e1e5e9;
    border-radius: 8px;
    overflow: hidden;
}

.table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr 2fr;
    gap: 16px;
    padding: 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e1e5e9;
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.participant-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr 2fr;
    gap: 16px;
    padding: 16px;
    border-bottom: 1px solid #f1f3f4;
    align-items: center;
}

.participant-row:last-child {
    border-bottom: none;
}

.participant-row:hover {
    background: #f8f9fa;
}

.participant-name {
    font-weight: 500;
    color: #333;
}

.participant-role {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
}

.participant-role.moderator {
    background: #fff3cd;
    color: #856404;
}

.participant-role.participant {
    background: #e2e3e5;
    color: #383d41;
}

.participant-join-time {
    font-size: 13px;
    color: #666;
}

.participant-actions {
    display: flex;
    gap: 8px;
}

.moderator-btn {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.moderator-btn.make {
    background: #28a745;
    color: white;
}

.moderator-btn.make:hover {
    background: #218838;
}

.moderator-btn.remove {
    background: #ffc107;
    color: #212529;
}

.moderator-btn.remove:hover {
    background: #e0a800;
}

.kick-btn {
    padding: 6px 12px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: background-color 0.2s ease;
}

.kick-btn:hover {
    background: #c82333;
}

.no-selection {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #666;
    font-size: 18px;
}

.admin-loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    gap: 20px;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
    .admin-content {
        flex-direction: column;
    }
    
    .admin-sidebar {
        width: 100%;
        max-height: 300px;
    }
    
    .table-header,
    .participant-row {
        grid-template-columns: 1fr;
        gap: 8px;
        text-align: left;
    }
    
    .participant-actions {
        justify-content: flex-start;
        margin-top: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./react/features/admin/components/web/AdminPage.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8EAA8E;AAClF;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;;QAEI,0BAA0B;QAC1B,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,eAAe;IACnB;AACJ","sourcesContent":["/* Admin Page Styles */\n\n.admin-page {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    background: #f5f5f5;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.admin-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 30px;\n    background: #fff;\n    border-bottom: 1px solid #e1e5e9;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.admin-header h1 {\n    margin: 0;\n    color: #333;\n    font-size: 28px;\n    font-weight: 600;\n}\n\n.refresh-btn {\n    padding: 10px 20px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s ease;\n}\n\n.refresh-btn:hover {\n    background: #0056b3;\n}\n\n.admin-content {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n}\n\n.admin-sidebar {\n    width: 400px;\n    background: #fff;\n    border-right: 1px solid #e1e5e9;\n    overflow-y: auto;\n    padding: 20px;\n}\n\n.admin-sidebar h2 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.room-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.room-item {\n    padding: 16px;\n    background: #f8f9fa;\n    border: 1px solid #e1e5e9;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.room-item:hover {\n    background: #e9ecef;\n    border-color: #007bff;\n}\n\n.room-item.selected {\n    background: #e3f2fd;\n    border-color: #007bff;\n}\n\n.room-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.room-header h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.room-status {\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n\n.room-status.active {\n    background: #d4edda;\n    color: #155724;\n}\n\n.room-status.inactive {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.room-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 12px;\n}\n\n.room-actions {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.delete-btn {\n    padding: 6px 12px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: background-color 0.2s ease;\n}\n\n.delete-btn:hover {\n    background: #c82333;\n}\n\n.admin-main {\n    flex: 1;\n    background: #fff;\n    padding: 30px;\n    overflow-y: auto;\n}\n\n.room-details h2 {\n    margin: 0 0 30px 0;\n    color: #333;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.participants-list h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.participants-table {\n    border: 1px solid #e1e5e9;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.table-header {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1.5fr 2fr;\n    gap: 16px;\n    padding: 16px;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e1e5e9;\n    font-weight: 600;\n    color: #333;\n    font-size: 14px;\n}\n\n.participant-row {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1.5fr 2fr;\n    gap: 16px;\n    padding: 16px;\n    border-bottom: 1px solid #f1f3f4;\n    align-items: center;\n}\n\n.participant-row:last-child {\n    border-bottom: none;\n}\n\n.participant-row:hover {\n    background: #f8f9fa;\n}\n\n.participant-name {\n    font-weight: 500;\n    color: #333;\n}\n\n.participant-role {\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: uppercase;\n    text-align: center;\n}\n\n.participant-role.moderator {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.participant-role.participant {\n    background: #e2e3e5;\n    color: #383d41;\n}\n\n.participant-join-time {\n    font-size: 13px;\n    color: #666;\n}\n\n.participant-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.moderator-btn {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.moderator-btn.make {\n    background: #28a745;\n    color: white;\n}\n\n.moderator-btn.make:hover {\n    background: #218838;\n}\n\n.moderator-btn.remove {\n    background: #ffc107;\n    color: #212529;\n}\n\n.moderator-btn.remove:hover {\n    background: #e0a800;\n}\n\n.kick-btn {\n    padding: 6px 12px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    transition: background-color 0.2s ease;\n}\n\n.kick-btn:hover {\n    background: #c82333;\n}\n\n.no-selection {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    color: #666;\n    font-size: 18px;\n}\n\n.admin-loading {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    gap: 20px;\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #007bff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .admin-content {\n        flex-direction: column;\n    }\n    \n    .admin-sidebar {\n        width: 100%;\n        max-height: 300px;\n    }\n    \n    .table-header,\n    .participant-row {\n        grid-template-columns: 1fr;\n        gap: 8px;\n        text-align: left;\n    }\n    \n    .participant-actions {\n        justify-content: flex-start;\n        margin-top: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
